/**
 * Maps a browser hostname to the environment tag Bugsink receives, so errors
 * from app-dev, aw-qa and aw-qa2 are not all reported as "production" (the
 * Sentry SDK's default). Only the production host maps to "production".
 */
export function sentryEnvironmentOf(hostname: string): string {
	const host = hostname.trim().toLowerCase().replace(/\.+$/, "");
	const parts = host.split(".");

	if (parts.length !== 3 || parts[1] !== "signalist" || parts[2] !== "io" || !parts[0]) {
		return "unknown";
	}

	const label = parts[0];

	if (label === "app") {
		return "production";
	}

	if (label === "app-dev") {
		return "develop";
	}

	if (label === "production") {
		return "unknown";
	}

	return label;
}
